<template>
  <div>
    <!--<h4>PEDIDOS </h4>-->
    <!-- <div class="alert alert-danger" v-show="!connected"> -->
    <!--   <i class="fas fa-circle-notch fa-spin"></i> Desconectado, buscando -->
    <!--   conexion ... -->
    <!-- </div> -->
    <div class="alert alert-info" v-show="loading">
      <i class="fas fa-circle-notch fa-spin"></i> Cargando nuevos pedidos ...
    </div>
    <div class="row">
      <div class="col">
        <h4 class="text-white bg-danger p-1 rounded">PARA LA MESA</h4>
        <ProductionQueue :list="toTable"></ProductionQueue>
      </div>
      <div class="col ">
        <!-- bg-secondary -->
        <!-- <h4 class="text-white"></h4> -->
        <h4 class="text-danger bg-warning p-1 rounded">PARA LLEVAR</h4>
        <ProductionQueue :list="toDelivery"></ProductionQueue>
      </div>
    </div>
  </div>
</template>
<script>
import { DinnerService } from "./DinnerService.js";
import { myMoment, momentDateFormat } from "src/lt-module/utils/myMoment.js";
import io from "socket.io-client";
import ProductionQueue from "./production-queue/ProductionQueue.vue";

export default {
  components: {
    ProductionQueue
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    list: [],
    categories: "",
    log: "",
    connected: false,
    socket: {},
    toTable: [],
    toDelivery: [],
    loading: false,
    lasyLoading: null,
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  created() {
    //
  },

  mounted() {
    this.getList();
    this.lasyLoading = setInterval(() => {
      this.getList();
    }, 60000);
    if (parseInt(process.env.VUE_APP_SOCKET_URL)) {
      this.beginSocketConnection();
    }
  },

  beforeDestroy() {
    this.socket.close && this.socket.close();
    clearInterval(this.lasyLoading);
  },

  methods: {
    beginSocketConnection() {
      var socket = io.connect(process.env.VUE_APP_SOCKET_URL);
      this.socket = socket;
      var callback = () => {
        this.getList();
      };
      var connectionErrorHandler = () => {
        this.connected = false;
      };
      this.socket.on("connect", () => {
        this.connected = true;
      });

      this.socket.on("connect_error", connectionErrorHandler);
      this.socket.on("disconnect", connectionErrorHandler);
      this.socket.on("sales.new", callback);
    },
    getList() {
      this.loading = true;
      DinnerService.getKitchenWorks({
        date: myMoment().format(momentDateFormat),
        maked: 0,
        categories: this.$store.state.config.dinner.client.categories || null,
        per_page: 10000
      }).then((res) => {
        this.loading = false;
        this.toTable = res.data.filter((x) => x.type_id == 1);
        this.toDelivery = res.data.filter(
          (x) => x.type_id == 2 || x.type_id == 3
        );
      });
    }
  }
};
</script>

<style scoped></style>
